var _path, _path2, _rect, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardPlaceholderBroken(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 140",
    role: "img",
    "aria-label": "Card image failed",
    fill: "none",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5h53l21 21v101a8 8 0 0 1-8 8H17a8 8 0 0 1-8-8V13a8 8 0 0 1 8-8Z",
    fill: "#F3F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 5v16a5 5 0 0 0 5 5h16"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 46,
    width: 50,
    height: 44,
    rx: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 58,
    r: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m26 81 15-17 14 16 8-9 11 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPlaceholderBroken);
export default __webpack_public_path__ + "static/media/card-placeholder-broken.edfdf5a6c05248e8e55f44f0d531606b.svg";
export { ForwardRef as ReactComponent };